import { AuthContext } from './AuthContext'
import { useContext, useEffect,FC } from 'react'
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../authConfig'
import { consolelog } from '../Utils/consolelog';

export const Authentication:FC<any> = ({children}) => {
    const authContext = useContext(AuthContext)
    const { instance } = useMsal();
    
    const loginHandler = () => {
        const account = instance.getActiveAccount();
        if (account) {
            instance.acquireTokenSilent(loginRequest).then((response) => {
                authContext.login(response.accessToken)
                authContext.token = response.accessToken
            }).catch((e) => {
                instance.acquireTokenPopup(loginRequest).then((response) => {
                    consolelog(response.accessToken);
                    authContext.login(response.accessToken)
                    authContext.token = response.accessToken
                });
            });
        }
    }
    
    useEffect(()=>{
        loginHandler()
    },[])
    

    return children
}
